import { WEEK } from 'shared/constants';

export const SESSION_TOKEN_ADDITION = WEEK;
export const SESSION_TOKEN_UPDATE_AVAILABLE = SESSION_TOKEN_ADDITION / 2;
